import { useCallback } from 'react';
import { createConversation, getConversationMessages } from '@wix/ambassador-genie-chat-service-v1-no-entity/http';
import { SortOrder } from '@wix/ambassador-genie-chat-service-v1-no-entity/types';
import { mapAssistantReference } from '../../../../mapAssistantReference';
export const useInitConversation = (httpClient, reference) => {
  return useCallback(async (strategy, limit) => {
    if (strategy.type === 'existing-conversation') {
      const {
        data: {
          messages,
          pagingMetadata
        }
      } = await httpClient.request(getConversationMessages({
        conversationId: strategy.id,
        sort: [{
          fieldName: 'createdDate',
          order: SortOrder.DESC
        }],
        cursorPaging: {
          limit
        }
      }));
      return {
        id: strategy.id,
        messages: (messages == null ? void 0 : messages.sort((a, b) => {
          var _a$createdDate, _b$createdDate;
          return (((_a$createdDate = a.createdDate) == null ? void 0 : _a$createdDate.getTime()) ?? 0) - (((_b$createdDate = b.createdDate) == null ? void 0 : _b$createdDate.getTime()) ?? 0);
        })) ?? [],
        pagingMetadata
      };
    }
    if (strategy.type === 'new-conversation') {
      const {
        data: {
          conversationId: newId
        }
      } = await httpClient.request(createConversation({
        origin: strategy.origin,
        assistantConfig: mapAssistantReference(reference)
      }));
      if (!newId) {
        throw new Error('conversationId is missing');
      }
      const {
        data: {
          messages,
          pagingMetadata
        }
      } = await httpClient.request(getConversationMessages({
        conversationId: newId,
        cursorPaging: {
          limit
        }
      }));
      return {
        id: newId,
        messages: messages ?? [],
        pagingMetadata
      };
    }
    throw new Error(`unknown strategy ${strategy.type}`);
  }, [httpClient, reference]);
};
//# sourceMappingURL=useInitConversation.js.map